import {
	LinearProgress,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
	withStyles,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { useDataProvider, useTranslate } from "react-admin";

const StyledTableRow = withStyles((theme) => ({
	root: {
		"&:hover": {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow);

const StyledTableHeaderRow = withStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.action.hover,
	},
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
	root: {
		border: `1px solid ${theme.palette.divider}`,
	},
}))(TableCell);

const Expand = ({ record }) => {
	const translate = useTranslate();
	const dataProvider = useDataProvider();
	const [header, setHeader] = React.useState({});
	const [records, setRecords] = React.useState([]);
	const [loading, setLoading] = React.useState(true);
	useEffect(() => {
		dataProvider
			.get(`bookmaker-imports/read/${record?.id}/${record?.csv_name}`, {
				filter: { status: "pending" },
			})
			.then(({ data }) => {
				const _data = data?.data;
				const header = _data?.[0];
				const records = _data?.slice(1);
				setRecords(records);
				setHeader(header);
				setLoading(false);
			});
	}, [dataProvider, record.csv_name, record.id]);

	if (loading) return <LinearProgress />;

	if (records.length === 0) {
		return <Typography>{translate("ra.page.empty")}</Typography>;
	}

	return (
		<TableContainer component="div" elevation={1}>
			<Table size="small">
				<TableHead>
					{Object.keys(header).length > 0 && (
						<StyledTableHeaderRow>
							{header.map((key) => (
								<StyledTableCell key={key} align="center">
									{key}
								</StyledTableCell>
							))}
						</StyledTableHeaderRow>
					)}
				</TableHead>
				<TableBody>
					{records.map((record, i) => (
						<StyledTableRow key={i}>
							{record.map((key, j) => (
								<StyledTableCell
									key={`${j}-${key}`}
									style={{
										fontWeight: i === 0 ? "bold" : "normal",
									}}
								>
									{key}
								</StyledTableCell>
							))}
						</StyledTableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default Expand;
